import React from 'react';
import './TVKnockoutBracket.scss';

const sid=(value:any)=>String(value?.id||value?._id||value||'');
const ROUND_ORDER=['ROUND_OF_64','ROUND_OF_32','ROUND_OF_16','ROUND_OF_8','QUARTER_FINAL','SEMI_FINAL','PLAYOFF','THIRD_PLACE','FINAL'];
const labels:any={ROUND_OF_64:'Round of 64',ROUND_OF_32:'Round of 32',ROUND_OF_16:'Round of 16',ROUND_OF_8:'Round of 8',QUARTER_FINAL:'Quarter-finals',SEMI_FINAL:'Semi-finals',PLAYOFF:'Play-off',THIRD_PLACE:'Third-place play-off',FINAL:'Final'};
const roundLabel=(value:string)=>labels[value]||String(value||'Knockout').replace(/_/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
const sourceLabel=(source:any,matches:any[])=>{
  if(source?.sourceType==='BYE')return 'Bye';
  if(source?.label)return source.label;
  if(source?.sourceType==='GROUP_POSITION'){const position=Number(source.sourcePosition);return `${position||''}${position===1?'st':position===2?'nd':position===3?'rd':'th'} place`;}
  if(source?.sourceType==='MATCH_LOSER'||source?.sourceType==='MATCH_WINNER'){
    const referenced=(matches||[]).find(match=>sid(match)===sid(source.sourceMatchId));
    const matchName=referenced?.name||'previous match';
    return `${source.sourceType==='MATCH_LOSER'?'Loser':'Winner'} of ${matchName}`;
  }
  return 'To be decided';
};

export const makeBracketSlides=(competitions:any[])=>competitions.flatMap(competition=>{
  const rounds=Array.from(new Set((competition.matches||[]).map((match:any)=>match.round||'KNOCKOUT'))).sort((a:any,b:any)=>{
    const ai=ROUND_ORDER.indexOf(a),bi=ROUND_ORDER.indexOf(b);return (ai<0?999:ai)-(bi<0?999:bi);
  });
  const largest=Math.max(1,...rounds.map(round=>(competition.matches||[]).filter((match:any)=>(match.round||'KNOCKOUT')===round).length));
  const pages=Math.max(1,Math.ceil(largest/8));
  return Array.from({length:pages},(_,page)=>({...competition,title:competition.title||competition.name||competition.label,rounds,page,pages,id:`bracket-${competition.id}-${page}`}));
});

export default function TVKnockoutBracket({slide,resolveMatch}:{slide:any;resolveMatch:(match:any)=>any}){
  return <div className="tvBracket">{slide.rounds.map((round:string,roundIndex:number)=>{
    const all=(slide.matches||[]).filter((match:any)=>(match.round||'KNOCKOUT')===round);
    const pageSize=Math.max(1,Math.ceil(all.length/slide.pages));
    const matches=all.slice(slide.page*pageSize,(slide.page+1)*pageSize);
    return <section className="tvBracket__round" key={round}><header><span>{String(roundIndex+1).padStart(2,'0')}</span><strong>{roundLabel(round)}</strong><small>{all.length} match{all.length===1?'':'es'}</small></header><div>{matches.map((match:any)=>{
      const view=resolveMatch(match),isBye=match.homeSource?.sourceType==='BYE'||match.awaySource?.sourceType==='BYE';
      return <article className={view.live?'is-live':''} key={sid(match)||match.name}>
        <small>{match.name||roundLabel(round)}{view.live&&<b>LIVE</b>}</small>
        <Team team={view.home} fallback={sourceLabel(match.homeSource,slide.matches)} score={view.score?.home}/>
        <Team team={view.away} fallback={sourceLabel(match.awaySource,slide.matches)} score={view.score?.away}/>
        {isBye&&<em>Advances automatically</em>}
      </article>})}</div></section>})}</div>;
}

const Team=({team,fallback,score}:{team:any;fallback:string;score?:number})=><div className="tvBracket__team">{team?.schoolPic?<img src={team.schoolPic} alt=""/>:<i>{(team?.schoolName||team?.name||fallback||'?').slice(0,1)}</i>}<span><strong>{team?.schoolName||fallback}</strong>{team?.name&&<small>{team.name}</small>}</span>{score!==undefined&&<b>{score}</b>}</div>;
